<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="add">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>

        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%"
        @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="contractNo" label="合同编号"></el-table-column>
        <el-table-column width="240" prop="width" label="合同效期">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}") }}
            {{ scope.row.startDate ? '至' : '' }}
            {{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="update(scope.row)"
              class="color-blue">编辑</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="title + '集采批次'" :visible.sync="open" :center="true" width="500px" :before-close="cancel"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="合同编号">
          <el-input v-model="form.contractNo" placeholder="请填写合同编号"></el-input>
        </el-form-item>
        <el-form-item label="合同效期">
          <el-date-picker v-model="form.date" type="daterange" style="width: 100%" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @input="dateChange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="预览" :visible.sync="preview" :center="true" :width="width + 40 + 'px'" :before-close="cancel"
      :close-on-click-modal="false">
      <div class="chart-background" :style="{ width: width + 'px', height: height + 'px' }">
        <component v-bind:is="chart" ref="chart" :name="name"></component>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetDistributionBatchs,
  SaveDistributionBatch,
  RemoveDistributionBatchs
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetDistributionBatchs,
      RemoveAction: RemoveDistributionBatchs,

      open: false,
      preview: false,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        component: [{ required: true, message: "请输入路径", trigger: "blur" }],
      },
      chart: null,
      name: '',
      width: 0,
      height: 0
    };
  },
  methods: {
    // 新建
    add() {
      this.open = true;
      this.title = "新建";
      this.resetForm();
    },
    // 编辑
    update(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      if (this.form.startDate) {
        this.$set(this.form, 'date', [this.form.startDate, this.form.endDate])
      }
      else {
        this.$set(this.form, 'date', ['', ''])
      }
      this.open = true;
      this.title = "编辑";
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.open = false;
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveDistributionBatch(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
          });
      });
    },
    resetForm() {
      this.form = {
        name: '',
        contractNo: '',
        remark: '',
        startDate: '',
        endDate: '',
        date: ['', ''],
        orgCode: sessionStorage.getItem('orgId'),
      }
    },
    dateChange(val) {
      this.$nextTick(() => {
        if (val == null) {
          this.form.startDate = "";
          this.form.endDate = "";
        } else {
          this.form.startDate = val[0];
          this.form.endDate = val[1];
        }
      });
    }
  },
  mounted() {

    console.log("1231")
  },
};
</script>

<style lang="scss" scoped>
.chart-background {
  background-image: url("../../../../assets/dp.png");
  // width: 400px;
  // height: 400px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
